import PropTypes from "prop-types";
import { Card } from "semantic-ui-react";
import React, { useRef } from "react";
import css from './RadioCardOption.css';
import Icon from 'SF/MaterialIcon';

function RadioCardOption(props) {
  const inputRef = useRef();
  
  const getAriaLabel = () =>
      props.label + (props.description ? ' ' + props.description : '');
  
  return (
    <Card 
      className={css['container']}
      style={{border: props.isChecked ? "1px solid #1E70A6" : null}}
      fluid
      onClick={() => {
        props.onSelect();
        inputRef.current.focus();
      }}>
      <div className={css['radio']}>
        <input
          className={css['input-radio']} 
          type="radio"
          ref={inputRef}
          onChange={props.onSelect}
          aria-label={getAriaLabel()}
          name={props.radioGroupName}
          checked={props.isChecked}
        />
      </div>
      <div className={css['text']} aria-hidden="true">
        <div className={css['first-row']}>
          {props.label}
        </div>
        {props.description && <div>
          <span className={css['second-row']}>
            {props.icon && <Icon 
              icon={props.icon} 
              className={css['second-row-icon']}
            />}
            {props.description}
          </span>    
        </div>}
      </div>
    </Card>
  );
}

RadioCardOption.propTypes = {
  onSelect: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  radioGroupName: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.string
};

export default RadioCardOption;
